module.exports = __webpack_public_path__ + "static/media/plein-air.b634d2b0.webp";